module.exports = __webpack_public_path__ + "img/img.e5dfcbf9.jpg";